// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3mbCC","col":"styles_col__rx3N5","fulfillmentStatus":"styles_fulfillmentStatus__2CFRS","emailCol":"styles_emailCol__2fGG2"};